module.exports = __webpack_public_path__ + "static/floorplan_05-a4b27664dfd81eed1f0f2fa3ced25b3a.jpg";